import styled from "styled-components";
export const DashboardManagementStyle = styled.div``;
